import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";
import { Cartesian3, CustomDataSource } from "cesium";
import { MapSearchState } from "../../../../map-search/state/map-search.state";
import { CameraHelperService, CesiumMapService, MapUtils } from "../../../index";

interface MapSearchLayerComponentState {
    selectedResultPosition: Cartesian3 | undefined;
}

@UntilDestroy()
@Component({
    selector: "dtm-map-search-layer",
    templateUrl: "./map-search-layer.component.html",
    styleUrls: ["./map-search-layer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class MapSearchLayerComponent {
    private readonly dataSource = new CustomDataSource();
    private readonly cesiumViewer = this.cesiumService.getViewer();

    protected selectedResultPosition$ = this.localStore.selectByKey("selectedResultPosition");

    constructor(
        private readonly store: Store,
        private readonly localStore: LocalComponentStore<MapSearchLayerComponentState>,
        private readonly cesiumService: CesiumMapService,
        private readonly cameraHelperService: CameraHelperService
    ) {
        this.localStore.setState({
            selectedResultPosition: undefined,
        });
        this.dataSource = new CustomDataSource();
        this.cesiumViewer.dataSources.add(this.dataSource);
        this.watchSelectedSearchResultAndUpdateLayer();
    }

    private watchSelectedSearchResultAndUpdateLayer() {
        this.store
            .select(MapSearchState.selectedSearchResult)
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                const { longitude, latitude } = result ?? {};
                if (!longitude || !latitude) {
                    this.localStore.patchState({ selectedResultPosition: undefined });

                    return;
                }

                this.localStore.patchState({
                    selectedResultPosition: MapUtils.convertSerializableCartographicToCartesian3({
                        latitude,
                        longitude,
                    }),
                });

                this.cameraHelperService.flyToPoint(latitude, longitude);
            });
    }
}
